<template>
    <VJoyWrapper direction="column" align="center" row-gap="6" no-margin>
        <VJoyWrapper direction="column" align="center" row-gap="2" no-margin>
            <VJoyIcon :name="icon" size="small" color="neutral" />
            <span class="empty-content-section__title">
                <VJoyText preset="primary-450">{{ title }}</VJoyText>
            </span>
            <span class="empty-content-section__description">
                <VJoyText>{{ description }}</VJoyText>
            </span>
        </VJoyWrapper>
        <slot class="empty-content-section__action" name="action" />
    </VJoyWrapper>
</template>
<script setup lang="ts">
    import {VJoyWrapper, VJoyIcon, VJoyText} from '@maltjoy/core-vue';
    import type {JoyIconsId} from '@maltjoy/icons';

    defineProps<{
        icon: JoyIconsId;
        title: string;
        description: string;
    }>();
</script>
<style lang="scss">
    .empty-content-section {
        &__title {
            text-align: center;
        }

        &__description {
            text-align: center;
        }

        &__action {
            margin-top: var(--joy-core-spacing-4);
        }
    }
</style>
